"use client";

import { useEffect, useState, useSyncExternalStore } from "react";
import MemberDashboard from "@/components/MemberDashboard";
import type { GalleryEvent } from "@/app/(site)/gallery/gallery-board";
import { readSession } from "@/lib/session";

const slides = [
  { src: "/assets/Agrohadham/1.webp", alt: "Mahalakshmi" },
  { src: "/assets/Agrohadham/2.webp", alt: "Maharaja" },
];

function memberNow() {
  const session = readSession();
  return session?.role === "member" || session?.role === "committee";
}

export default function HomeExperience({ albums }: { albums: GalleryEvent[] }) {
  const isMember = useSyncExternalStore(() => () => {}, memberNow, () => false);
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    document.title = isMember ? "Member Dashboard | AVT Kalamboli" : "Home | AVT Kalamboli";
    if (isMember) return undefined;
    const timer = window.setInterval(() => {
      setCurrentSlide((current) => (current + 1) % slides.length);
    }, 4000);
    return () => window.clearInterval(timer);
  }, [isMember]);

  if (isMember) return <MemberDashboard albums={albums} />;

  return (
    <main>
      <style>{`
        .hero-slideshow {
          width: 100%;
          height: 600px;
          background-color: #000;
        }
        .hero-slideshow .slide {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
        }
      `}</style>
      <section className="hero-banner" id="home">
        <div className="hero-slideshow">
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img src={slides[0].src} className={currentSlide === 0 ? "slide active" : "slide"} alt={slides[0].alt} />
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img src={slides[1].src} className={currentSlide === 1 ? "slide active" : "slide"} alt={slides[1].alt} />
        </div>
      </section>
      <section className="features-section container">
        <div className="feature-card modern-card">
          <h3>Sewa (Service)</h3>
          <p>Selfless service to humanity through medical camps, food distribution, and community support.</p>
        </div>
        <div className="feature-card modern-card">
          <h3>Shiksha (Education)</h3>
          <p>Empowering the next generation with scholarships, guidance, and educational institutions.</p>
        </div>
        <div className="feature-card modern-card">
          <h3>Sangathan (Unity)</h3>
          <p>Bringing families together to celebrate festivals, culture, and the Agrawal heritage.</p>
        </div>
      </section>
    </main>
  );
}
